import React from 'react';
import styled, { css } from 'styled-components';
import { useBlogItems } from '../../hooks/use-blog-items';
import parseStoryblokLink from '../../utils/parseStoryblokLink';
import Button from '../button';
import BlogItemCard from './BlogItemCard';
import Container from '../container';
import mq from '../../utils/mq';
import RichtextParser from '../../utils/richtext-parser';
import { styledLink } from '../../utils/styles';

const LatestNewsAndInsightsOuterContainer = styled.div`
  background-color: #fff;
  padding-top: 104px;
  padding-bottom: 50px;
  ${mq.mobile(css`
    padding-top: 64px;
    padding-bottom: 0;
  `)};
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mq.mobile(css`
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    justify-content: flex-start;
  `)};
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.h2`
  color: #161616;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  ${mq.mobile(css`
    font-size: 36px;
  `)};
`;

const Description = styled.div`
  color: var(--Foreground-fg-secondary, #565656);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  a {
    ${styledLink};
    text-decoration: none;
  }
`;

const CtaContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const BlogItemsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 20px;
  grid-row-gap: 40px;
  margin-top: 64px;
  ${mq.mobile(css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-top: 32px;
  `)};
`;

export default function LatestNewsAndInsights({
  sectionTitle,
  sectionDescription,
  sectionCtaLabel,
  sectionCtaLink
}: {
  sectionTitle: string;
  sectionDescription: string;
  sectionCtaLabel: string;
  sectionCtaLink: string;
}) {
  const blogItems = useBlogItems();

  return (
    <LatestNewsAndInsightsOuterContainer>
      <Container>
        <TitleSection>
          <TitleContent>
            <Title>{sectionTitle}</Title>
            <Description
              dangerouslySetInnerHTML={{
                __html: RichtextParser(sectionDescription)
              }}
            />
          </TitleContent>
          <CtaContainer>
            <Button to={parseStoryblokLink(sectionCtaLink as any)} borderGrey>
              {sectionCtaLabel}
            </Button>
          </CtaContainer>
        </TitleSection>

        <BlogItemsGrid>
          {blogItems?.map((blogItem: any, index: number) => (
            <BlogItemCard
              key={blogItem.id}
              firstItem={index === 0}
              blogItem={blogItem}
            />
          ))}
        </BlogItemsGrid>
      </Container>
    </LatestNewsAndInsightsOuterContainer>
  );
}
